import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_LOCATION = 'CREATE_LOCATION';
export const CREATE_LOCATION_SUCCESS = 'CREATE_LOCATION_SUCCESS';
export const CREATE_LOCATION_FAILURE = 'CREATE_LOCATION_FAILURE';

// Action Creators
export const createLocation = () => ({
  type: CREATE_LOCATION,
});

export const createLocationSuccess = (data) => ({
  type: CREATE_LOCATION_SUCCESS,
  payload: data,
});

export const createLocationFailure = (error) => ({
  type: CREATE_LOCATION_FAILURE,
  payload: error,
});

// Thunk Function
export const createLocationCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(createLocation());
    try {
      const response = await postMethodWithToken(
        url.staff + data?.enterpriseId + '/locations/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(createLocationSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(createLocationFailure(response?.data));
      }
    } catch (error) {
      dispatch(createLocationFailure(error?.message));
    }
  };
};
